import { Box, TextField } from "@mui/material"
import { useState, useEffect } from "react"
import { balanceService } from "services/balanceService"
import { ContainerHeader, ContainerPage } from "./styles"
import { PageTitle } from "components"
import { useTableParams } from "hooks/useTableParams"
import { Table } from "shared"
import { IBalanceDataResponse } from "interfaces/IBalance"

const Balance = () => {
  const [scheduledDate, setScheduledDate] = useState(getInitialDeliveryDate())
  const { count, data, params, refresh, onChange, status } = useTableParams({
    service: (params: any) => balanceService.getAllBalancesToday(params),
    paramsDefault: { orderBy: ["-isInReplenishment", "-requiresReplenishment"] },
  })

  function getInitialDeliveryDate() {
    const now = new Date()
    const hours = now.getHours()

    if (hours >= 7) {
      now.setDate(now.getDate() + 1)
    }

    const localDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0]

    return localDate
  }

  const handleSearchByDate = (date: any) => {
    setScheduledDate(date)
    onChange({ ...params, scheduledDate: date })
  }

  const handleSkuSearch = (skuName: any) => {
    onChange({ ...params, skuName })
  }

  return (
    <>
      <ContainerPage style={{ height: "auto" }}>
        <ContainerHeader component="header" style={{ display: "flex", flexDirection: "column" }}>
          <PageTitle>Balanço Geral</PageTitle>
          <h2 style={{ marginTop: "10px", fontSize: "1.25rem", color: "#637381", fontWeight: 400 }}>
            Aqui você encontra o balanço de abastecimento de itens.
          </h2>
        </ContainerHeader>

        <Box display="flex" alignItems="center" style={{ marginTop: "20px" }}>
          <TextField
            type="date"
            label="Data de Entrega"
            variant="outlined"
            value={scheduledDate}
            onChange={e => handleSearchByDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: "20px" }}
          />
          <TextField
            label="Buscar SKU"
            variant="outlined"
            onChange={e => handleSkuSearch(e.target.value)}
            style={{ marginRight: "20px" }}
          />
        </Box>
        <Table
          columns={[
            {
              style: { fontSize: "1.2rem" },
              field: "skuName",
              label: "Produto",
            },
            {
              style: { fontSize: "1.2rem" },
              field: "totalSold",
              label: "Vendido",
            },
            {
              style: { fontSize: "1.2rem" },
              field: "totalSeparated",
              label: "Separado",
            },
            {
              style: { fontSize: "1.2rem" },
              field: "totalReplenished",
              label: "Abastecido",
            },
            {
              style: { fontSize: "1.2rem" },
              field: "quantityInSeparation",
              label: "Operação",
            },
            {
              style: { fontSize: "1.2rem" },
              field: "marketNumber",
              label: "Mercado",
            },
            {
              style: { fontSize: "1.2rem" },
              field: "isInReplenishmentForWorkId",
              label: "Status",
              renderCell: (row: { data: IBalanceDataResponse }) => {
                const { requiresReplenishment, isInReplenishmentForWorkId, isStockout } = row.data

                if (requiresReplenishment && !isInReplenishmentForWorkId && !isStockout) {
                  return "Aguardando"
                }
                if (isStockout) {
                  return "Sem estoque"
                }
                if (isInReplenishmentForWorkId) {
                  return "Abastecendo"
                }
                return "OK"
              },
            },
          ]}
          data={data as IBalanceDataResponse[]}
          params={params}
          onChange={onChange}
          refresh={refresh}
          count={count}
          status={status}
          rowStyle={() => ({ ".MuiTableCell-root": { fontSize: "1.1rem" } })}
        />
      </ContainerPage>
    </>
  )
}

export default Balance
